import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/config/error";
const I18n = I18nUtil.createScoped(Translations);
export const errorCode = {
  // General Errors (1xxxx)
  INTERNAL_ERROR: 10001,
  INVALID_PARAMS: 10002,
  CHAT_ANSWER_FAILED: 10003,
  // Auth Errors (2xxxx)
  UNAUTHORIZED: 20001,
  INVALID_TOKEN: 20002,
  GUEST_ID_INVALID: 20003,
  AUTH_FAILED: 20004,
  ACCESS_CODE_INVALID: 20005,
  // Chat Errors (3xxxx)
  CHAT_NOT_FOUND: 30001,
  CHAT_ID_INVALID: 30002,
  MESSAGE_NOT_FOUND: 30003,
  MESSAGE_INVALID: 30004,
  CHAT_PROGRESS: 30005,
  // Share Errors (4xxxx)
  SHARE_NOT_FOUND: 40001,
  SHARE_EXPIRED: 40002,
  // File Errors (5xxxx)
  FILE_TYPE_NOT_SUPPORTED: 50001,
  FILE_UPLOAD_FAILED: 50002,
  // Rate Limit Errors (6xxxx)
  RATE_LIMIT_EXCEEDED: 60001,
  LIMIT_TIMES: 60001, // 风控
  DEEP_SEARCH_RATE_LIMIT_EXCEEDED: 60002, // 风控
  RISK_TRIGGER: 20006, // 风控
  CREDITS_LIMITED: 70004,
  CREDIT_NOT_ENOUGH: 150015, // 积分不足
  NETWORK_ERROR: "NETWORK_ERROR", // 网络错误
};

export const getErrors = () => {
  return [
    {
      code: errorCode.INTERNAL_ERROR,
      msg: I18n.t("Internal server error"),
    },
    {
      code: errorCode.INVALID_PARAMS,
      msg: I18n.t("Invalid parameters"),
    },
    {
      code: errorCode.CHAT_ANSWER_FAILED,
      msg: I18n.t("Something went wrong. Please try again."),
    },
    {
      code: errorCode.UNAUTHORIZED,
      msg: I18n.t("Unauthorized access"),
    },
    {
      code: errorCode.INVALID_TOKEN,
      msg: I18n.t("Invalid token"),
    },
    {
      code: errorCode.GUEST_ID_INVALID,
      msg: I18n.t("Guest ID is invalid or missing"),
    },
    {
      code: errorCode.AUTH_FAILED,
      msg: I18n.t("Authentication failed"),
    },
    {
      code: errorCode.ACCESS_CODE_INVALID,
      msg: I18n.t("Access code not bind"),
    },
    {
      code: errorCode.CHAT_NOT_FOUND,
      msg: I18n.t("Chat not found"),
    },
    {
      code: errorCode.CHAT_ID_INVALID,
      msg: I18n.t("Invalid chat ID"),
    },
    {
      code: errorCode.MESSAGE_NOT_FOUND,
      msg: I18n.t("Message not found"),
    },
    {
      code: errorCode.MESSAGE_INVALID,
      msg: I18n.t("Invalid Message"),
    },
    {
      code: errorCode.CHAT_PROGRESS,
      msg: I18n.t("Chat is already in progress"),
    },
    {
      code: errorCode.SHARE_NOT_FOUND,
      msg: I18n.t("Share not found"),
    },
    {
      code: errorCode.SHARE_EXPIRED,
      msg: I18n.t("Share has expired"),
    },
    {
      code: errorCode.FILE_TYPE_NOT_SUPPORTED,
      msg: I18n.t("File type is not supported"),
    },
    {
      code: errorCode.FILE_UPLOAD_FAILED,
      msg: I18n.t("File upload failed"),
    },
    {
      code: errorCode.RATE_LIMIT_EXCEEDED,
      msg: I18n.t(
        "Ser, slow down. AI needs oxygen, and you need to touch grass.",
      ),
    },
    {
      code: errorCode.DEEP_SEARCH_RATE_LIMIT_EXCEEDED,
      msg: I18n.t("Deepsearch limit reached, switched to standard responses."),
    },
    {
      code: errorCode.RISK_TRIGGER,
      msg: I18n.t(
        "Your account has been flagged as a risky account. Please contact us via Discord to unblock it.",
      ),
    },
  ];
};
